const MessageCode = {
    SERVER_ERROR: 'SYSMSG001',
    CHANGE_PERMISSION_ADMIN_LAST_ERROR: 'USER01MSG005',
    CHANGE_PERMISSION_ADMIN_OWNER: 'MSG-CHANGE-AUTHORITY-REPRESENT-USER',
    DELETE_ADMIN_LAST_ERROR: 'USER01MSG006',
    SUB_DOMAIN_DUPLICATION: 'COMM01MSG04',
    SUB_DOMAIN_AND_EMAIL_IN_WATING_APPROVE: 'COMM01MSG15',
    SUB_DOMAIN_APPROVED: 'COMM02MSG09',
    CORPORATION_APPROVED: 'COMM02MSG07',
    CORPORATION_REJECTED: 'COMM02MSG08',
    USER_DUPLICATION: 'USER01MSG001',
    PROJECT_DUPLICATION: 'USER03MSG001',
    CHANGE_MANAGER_LAST_ERROR: 'USER01MSG009',
    PROJECT_MANAGER_NOT_ERROR: 'USER01MSG010',
    SEARCH_NOT_FOUND_ERROR: 'COMMSG001',
    MAX_GUEST_DESK_PROJECT_ERROR: 'USER04MSG007',
    LINK_INVITE_USED: 'COMM01MSG10',
    EXISTS_EMAIL_IN_ORG: 'COMMSG040',
    EXISTS_REGISTER_GUEST_CONTRACT: 'COMM01MSG15',
    EXISTS_CONTRACT: 'COMM02MSG09',
    ADD_CUSTOMER_EMAIL_INVALID: 'USER09MSG002',
    DUPLICATE_UPDATE_STATUS: 'USER04MSG024',
    TWO_USERS_CHANGE_ASSIGNEE: 'USER04MSG024',
    DATA_CHANGED_PLEASE_RELOAD: 'COMMSG030',
    EXISTS_B2B_CUSTOMER: 'USER04MSG031',
    EXISTS_USER_IN_ORG: 'COMM01MSG09',
    MAX_GENERAL_ID_ERROR: 'USER03MSG007',
    MSG_CM_DELETED_TICKET: 'MSG-CM-DELETED-TICKET',
    REQUIRED_FIELD_ERROR: 'COMMSG014',
    MAX_LENGTH_ERROR: 'COMMSG022',
    MIN_LENGTH_ERROR: 'COMMSG026',
    DATA_DUPLICATE: 'MSG-CM-DATA-DUPLICATION',
    RELOAD_PRODUCT_LIST_DELETED: 'COMMSG030-PRODUCT_DELETED',
    MSG_ORG_NOTICE_FOR_COMPLETING_REGISTRATION_CONFIRMATION_BEFORE: 'MSG-ORG-NOTICE-FOR-COMPLETING-REGISTRATION-CONFIRMATION-BEFORE',
    MSG_ORG_TRIAL_EDITION_NOT_AVAILABLE: 'MSG-ORG-TRIAL-EDITION-NOT-AVAILABLE',
    MSG_ORG_CANCEL_ORG_REGISTRATION_SUCCESS: 'MSG-ORG-CANCEL-ORG-REGISTRATION-SUCCESS',
    MSG_CM_SUBDOMAIN_DATA_DUPLICATION: 'MSG-CM-SUBDOMAIN-DATA-DUPLICATION',
    MSG_ORG_COMPLETE_ORG_REGISTRATION_SUCCESS: 'MSG-ORG-COMPLETE-ORG-REGISTRATION-SUCCESS',
    MSG_CM_EMAIL_DATA_DUPLICATION: 'MSG-CM-EMAIL-DATA-DUPLICATION',
    MSG_PROJECT_NAME_EMPTY: 'MSG_PROJECT_NAME_EMPTY',
    MSG_UPDATE_PROFILE_PROJECT_NAME_MAXLENGTH_ERROR: 'MSG_UPDATE_PROFILE_PROJECT_NAME_MAXLENGTH_ERROR',
    MSG_UPDATE_PROFILE_PROJECT_NAME_DUPLICATE: 'MSG_UPDATE_PROFILE_PROJECT_NAME_DUPLICATE',
    CBOTLB001: '問題は解決しましたか？',
    MSG_UPDATE_IP_ADDRESS_MAX_EXCCED: 'MSG_UPDATE_IP_ADDRESS_MAX_EXCCED',
    MSG_UPDATE_IP_ADDRESS_WRONG_FORMAT: 'MSG_UPDATE_IP_ADDRESS_WRONG_FORMAT',
    MSG_UPDATE_IP_ADDRESS_WRONG_FORMAT_DUPLICATE: 'MSG_UPDATE_IP_ADDRESS_WRONG_FORMAT_DUPLICATE',
    MSG_UPDATE_IP_ADDRESS_EMPTY: 'MSG_UPDATE_IP_ADDRESS_EMPTY',
    MSG_EMAIL_TICKET_DUPLICATED_PROJECT_EMAIL: 'MSG_EMAIL_TICKET_DUPLICATED_PROJECT_EMAIL',
    MSG_TELEPHONE_TICKET_DUPLICATED_PROJECT_TEL_NUMBER: 'MSG_TELEPHONE_TICKET_DUPLICATED_PROJECT_TEL_NUMBER',
    MSG_HOLD_WARNING_TIME_INVALID: 'MSG_HOLD_WARNING_TIME_INVALID',
    MSG_TOOLS_CALL_TIMEOUT_INVALID: 'MSG_TOOLS_CALL_TIMEOUT_INVALID',
    MSG_KNOW_TELEPHONE_AGENT_DISABLED_DUPLICATE: 'MSG-KNOW-TELEPHONE-AGENT-DISABLED-DUPLICATE',
    MSG_KNOW_KBOARD_DISABLED_DUPLICATE: 'MSG-KNOW-KBOARD-DISABLED-DUPLICATE',
};


export default MessageCode;
